<template>
    <div class="authentication-wrapper authentication-cover">
        <div class="authentication-inner row m-0">
            <slot />
        </div>
    </div>
</template>
